import i18n from 'i18next';
import { get } from 'lodash';
import moment from 'moment';

//format transactionsData
//return [{col1:val1, col2:val2}]
//where col1 is column name and val1 is col1 value
export const formatTransations = data =>
  data.map(item => ({
    Amount: new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: item.currency || 'USD',
    }).format(Number((item.amount / 100).toFixed(2))),
    Status: item.paid ? 'Succeeded' : 'Failed',
    Description: item.description,
    Customer: item.customer
      ? item.customer.email
      : item.billing_details
      ? item.billing_details.name
      : '',
    PlanName: item.invoice
      ? get(item.invoice.subscription_details.metadata, 'name') ||
        get(item.invoice.lines.data[0], 'description')
      : '-',
    StartDate:
      item.invoice && item.invoice.period_start
        ? moment(item.invoice.period_start * 1000).format('DD/MM/YYYY')
        : '-',
    EndDate:
      item.invoice &&
      item.invoice.lines &&
      item.invoice.lines.data &&
      item.invoice.lines.data[0].price.recurring
        ? moment(item.invoice.lines.data[0].period.end * 1000).format(
            'DD/MM/YYYY',
          )
        : '-',
    Invoice: item.invoice ? item.invoice.invoice_pdf : i18n.t('No Invoice'),
    Date: item.created
      ? moment(item.created * 1000).format('DD/MM/YYYY')
      : null,
  }));
